module.exports = __webpack_public_path__ + "img/blue_092.046eb448.png";